import { ShowAllTitle } from '@components/atoms/ShowAllTitle/ShowAllTitle';
import { Listicles } from '@components/organisms/Listicles/Listicles';
import { ListicleType } from '@src/lib/graphql/generated';

export const PageContentElementTvmAutomaticLanes = (element) => {
  if (!element?.lanes) return null;

  return (
    <div className="flex flex-col gap-24">
      {element?.lanes?.map((lane) => (
        <div key={lane?.title} className="relative pl-4 sm:pl-8 lg:pl-16">
          <ShowAllTitle title={lane.title} link={lane.title_link} />
          <Listicles
            dataSet={[]}
            listicle_type={ListicleType.Manual}
            items={lane?.entries.map((entry) => entry.id)}
            query=""
          />
        </div>
      ))}
    </div>
  );
};

export default PageContentElementTvmAutomaticLanes;
